// Turns rows into CSV text (Excel / Google Sheets friendly) and hands it to the
// person as a file.
import { Capacitor } from "@capacitor/core";

const cell = (value) => {
  const s = value === null || value === undefined ? "" : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// `columns` is [[header, row => value], ...].
export const toCsv = (rows, columns) =>
  [columns.map(([header]) => cell(header)).join(","), ...rows.map((row) => columns.map(([, get]) => cell(get(row))).join(","))].join("\r\n");

// In the phone app, where a download has nowhere to go, the file is shared (to
// Drive, WhatsApp, email...) if the phone allows it; everywhere else it downloads.
// (Desktop browsers can often share too, but a download is what's expected there.)
// A byte-order mark up front makes Excel read ₹ and other characters correctly.
export const saveCsv = async (filename, text) => {
  const blob = new Blob(["﻿", text], { type: "text/csv;charset=utf-8" });
  if (Capacitor.isNativePlatform()) {
    try {
      const file = new File([blob], filename, { type: "text/csv" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
        return;
      }
    } catch (err) {
      if (err && err.name === "AbortError") return; // the person closed the share sheet
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// The columns used for a list of transactions (expenses and income together).
export const TRANSACTION_COLUMNS = [
  ["Date", (e) => e.date],
  ["Kind", (e) => (e.kind === "income" ? "Income" : "Expense")],
  ["Name", (e) => e.label],
  ["Type", (e) => e.type],
  ["Amount", (e) => e.amount],
  ["Status", (e) => e.status],
  ["Description", (e) => e.description || ""],
];
